import items from '../../assets/items_with_german.json'
import { createSignal } from 'solid-js';
import { Show } from 'solid-js/web';
import { useApi, isOk } from '../../api';
import { useNavigate } from '@solidjs/router';
import Text from '../../components/Text';
import { useTranslation } from '../../hooks/useTranslation';
import { useToast } from '../../components/MessageBox';
import ItemStackView from '../../components/ItemStackView';
import { fromIdentifier } from '../../services/itemRefAdapters';

interface Item {
    id: number;
    name: string;
    displayName: string;
    stackSize: number;
    german: string;
}

export function NewItem() {
    const { t } = useTranslation();
    const toast = useToast();
    const itemsSource = items as Item[];

    const [selectedItem, select] = createSignal<Item | null>(null);
    const [currentItems, setCurrentItems] = createSignal<Item[]>(itemsSource);

    const api = useApi();
    const navigate = useNavigate();

    async function anlegen() {
        const res = await api.itemEntry.postItemEntry({
            minecraftId: selectedItem()?.name ?? '',
            singlePrice: 0,
            halfStackPrice: 0,
            stackPrice: 0,
            doubleChestPrice: 0,
            nbt: '',
            enchantments: ''
        });
        if (isOk(res.data)) {
            toast?.info(t('ITEM_CREATED'));
            navigate('/items');
        } else {
            toast?.error(t('ITEM_CREATE_FAILED'));
        }
    }

    return (
        <div class='dashboard-page'>
            <div class='v'>
                <h1><Text val="NEW_ITEM" /></h1>
                <input type="text" class="form-control" placeholder="Suche..." onInput={(e: any) => {
                    const search = e.target.value.toLowerCase();
                    setCurrentItems(itemsSource.filter(item => item.displayName.toLowerCase().includes(search) || item.german.toLowerCase().includes(search)));
                }} />
                <div class="list-group">
                    {currentItems().slice(0, 10).map(item => (
                        <span class='row search-res' onClick={() => {
                            select(item);
                            document.getElementById('details')?.scrollIntoView();
                        }}>
                            <ItemStackView stack={fromIdentifier(`minecraft:${item.name}`)} />
                            <span class="list-group-item">{item.german}</span>
                        </span>
                    ))}
                </div>
            </div>
            <div id="container" class='container'>
                <h1><Text val="DETAILS" /></h1>
                <Show when={selectedItem()}>
                    <div class='container'>
                        <div class="card">
                            <div class="card-body">
                                <div class='slimcontainer row'>
                                    <ItemStackView stack={fromIdentifier(`minecraft:${selectedItem()?.name || ''}`)} />
                                    <h5 class="card-title">{selectedItem()?.german}</h5>
                                </div>
                                <p class="card-text">ID: {selectedItem()?.id}</p>
                                <p class="card-text">Name: {selectedItem()?.name}</p>
                                <p class="card-text">StackSize: {selectedItem()?.stackSize}</p>
                            </div>
                        </div>
                        <input type="number" class="form-control" placeholder={t('ITEM_SINGLE_PRICE')} />
                        <input type="number" class="form-control" placeholder={t('ITEM_HALF_STACK')} />
                        <input type="number" class="form-control" placeholder={t('ITEM_STACK')} />
                        <input type="number" class="form-control" placeholder={t('ITEM_DK')} />
                        <button onClick={anlegen}><Text val="CREATE" /></button>
                    </div>
                </Show>
            </div>
        </div>
    );
}